import { AUStatesOptions, CAProvincesOptions, CAProvincesOptionsFr } from '~/config/common.js'

// NOTE: When setting SFCC AU user profile, the locale should be default instead of en-AU
const localeConfig: LocaleConfig = {
  'en-AU': {
    code: 'en-AU',
    iso: 'en-AU',
    file: 'en.js',
    currency: 'AUD',
    country: 'AU',
    siteId: 'MichaelHillAU',
    domain: process.env.DOMAIN_EN_AU || 'www.michaelhill.com.au',
    pathPrefix: null,
    slugManagerLocaleFallBack: null,
    language: 'English',
    languageCode: 'en',
    postCodeValidation: 'postcode_au',
    stateOptions: AUStatesOptions,
    sfccApiDomainWithLocale: 'michaelhill.com.au',
    newsletterEmailAddress: 'news@email.michaelhill.com.au',
    zendeskCountryName: 'country_australia',
    mainPostcode: '2000', //Sydney
  },
  'en-CA': {
    code: 'en-CA',
    iso: 'en-CA',
    file: 'en.js',
    currency: 'CAD',
    country: 'CA',
    siteId: 'MichaelHillCA',
    domain: process.env.DOMAIN_EN_CA || 'www.michaelhill.ca',
    pathPrefix: null,
    slugManagerLocaleFallBack: null,
    language: 'English',
    languageCode: 'en',
    postCodeValidation: 'postcode_ca',
    stateOptions: CAProvincesOptions,
    sfccApiDomainWithLocale: 'michaelhill.ca/en',
    newsletterEmailAddress: 'news@email.michaelhill.ca',
    zendeskCountryName: 'country_canada',
    mainPostcode: 'L7G 0J1', // Toronto
  },
  fr: {
    code: 'fr-CA',
    iso: 'fr-CA',
    file: 'fr.js',
    currency: 'CAD',
    country: 'CA',
    siteId: 'MichaelHillCA',
    domain: process.env.DOMAIN_EN_CA || 'www.michaelhill.ca',
    pathPrefix: 'fr',
    slugManagerLocaleFallBack: 'en-CA',
    language: 'French',
    languageCode: 'fr',
    postCodeValidation: 'postcode_ca',
    stateOptions: CAProvincesOptionsFr,
    sfccApiDomainWithLocale: 'michaelhill.ca/fr',
    newsletterEmailAddress: 'news@email.michaelhill.ca',
    zendeskCountryName: 'country_canada',
    mainPostcode: 'H3B 1A4', // Montreal
  },
  'en-NZ': {
    code: 'en-NZ',
    iso: 'en-NZ',
    file: 'en.js',
    currency: 'NZD',
    country: 'NZ',
    siteId: 'MichaelHillNZ',
    domain: process.env.DOMAIN_EN_NZ || 'www.michaelhill.co.nz',
    pathPrefix: null,
    slugManagerLocaleFallBack: null,
    language: 'English',
    languageCode: 'en',
    postCodeValidation: 'postcode_nz',
    stateOptions: [],
    sfccApiDomainWithLocale: 'michaelhill.co.nz',
    newsletterEmailAddress: 'news@email.michaelhill.co.nz',
    zendeskCountryName: 'country_new_zealand',
    mainPostcode: '1010', // Auckland
  },
}

export default localeConfig
